import { render, staticRenderFns } from "./Repasses.vue?vue&type=template&id=18300b94&scoped=true&"
import script from "./Repasses.vue?vue&type=script&lang=js&"
export * from "./Repasses.vue?vue&type=script&lang=js&"
import style0 from "./Repasses.vue?vue&type=style&index=0&id=18300b94&scoped=true&lang=css&"
import style1 from "./Repasses.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18300b94",
  null
  
)

export default component.exports